import { Link } from 'react-router';
import { HelpCircle } from 'lucide-react';

interface HelpButtonProps {
  to: string;
}

/**
 * Small "?" icon button linking to a documentation page.
 * Place next to page titles for contextual help.
 */
export function HelpButton({ to }: HelpButtonProps) {
  return (
    <Link
      to={to}
      className="flex h-7 w-7 items-center justify-center rounded-full text-muted-foreground/50 transition-colors hover:bg-gray-100 hover:text-[var(--vivid-purple)]"
      title="Ajutor"
    >
      <HelpCircle className="h-4 w-4" />
    </Link>
  );
}
